import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { getCategory } from "@/data/site";

export const ServiceCard = ({ service, index = 0 }) => {
  const category = getCategory(service.category);
  return (
    <Reveal delay={(index % 3) * 0.1}>
      <Link
        to={`/services/${service.category}/${service.slug}`}
        data-testid={`service-card-${service.slug}`}
        className="group block bg-cream border border-bronze/10 rounded-2xl overflow-hidden transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-bronze/30 hover:shadow-[0_24px_50px_rgba(140,90,60,0.12)]"
      >
        <div className="relative h-60 overflow-hidden bg-alabaster">
          <img
            src={service.image}
            alt={service.name}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <span className="absolute top-4 left-4 rounded-full bg-sand/85 backdrop-blur px-3.5 py-1.5 text-[0.65rem] uppercase tracking-[0.2em] text-bronze">
            {category?.name}
          </span>
        </div>
        <div className="p-6">
          <div className="flex items-start justify-between gap-3">
            <h3 className="font-serif text-xl sm:text-2xl text-ink">{service.name}</h3>
            <span className="mt-1 shrink-0 rounded-full border border-bronze/20 p-2 text-bronze transition-colors duration-300 group-hover:bg-bronze group-hover:text-cream">
              <ArrowUpRight size={15} />
            </span>
          </div>
          <p className="mt-2 text-sm leading-relaxed text-stone2">{service.excerpt}</p>
          <div className="mt-4 flex flex-wrap gap-2">
            {service.benefits.slice(0, 2).map((b) => (
              <span
                key={b}
                className="rounded-full bg-alabaster px-3 py-1 text-[0.65rem] uppercase tracking-[0.12em] text-bronze/80"
              >
                {b}
              </span>
            ))}
          </div>
          <p className="mt-5 text-[0.7rem] uppercase tracking-[0.22em] text-gold">
            View Details &amp; Book
          </p>
        </div>
      </Link>
    </Reveal>
  );
};
